__turbopack_context__.v({
  "tag": "Tag-module__mI1Ehq__tag",
});
